package com.mrpowergamerbr.puppydough.webrune

import js.buffer.ArrayBuffer
import js.date.Date
import js.objects.Record
import js.promise.Promise
import js.typedarrays.Uint8Array
import kotlinx.js.JsPlainObject
import web.html.HTMLCanvasElement

@JsExport
class PreloadEntry(
    val gameFolder: String,
    val gameFileName: String,
    val urlPath: String
)

@JsPlainObject
external interface GameStorageEntry {
    var timestamp: Date
    var mode: Int
    var contents: Uint8Array<*>?
}

@JsPlainObject
external interface GameStorageListEntry {
    val timestamp: Date
}

external interface GameStorage {
    fun list(): Promise<Record<String, GameStorageListEntry>>
    fun get(path: String): Promise<GameStorageEntry>
    fun put(entry: GameStorageEntry, path: String): Promise<Unit>
    fun delete(path: String): Promise<Unit>
}

external fun startYYRunner(
    versionId: String,
    canvas: HTMLCanvasElement,
    workdir: String,
    preloadFiles: Array<PreloadEntry>,
    oprt: GameStorage,
    onRequest: (String) -> (Promise<ArrayBuffer>?),
    onMedia: (String) -> (Promise<String>?),
    onGameChange: (String, String) -> Unit,
    // Called once when the runner has loaded everything and is holding before booting the game
    // Call the received function to let it boot
    onReady: (start: () -> Unit) -> Unit,
    onExit: () -> Unit
): Promise<Unit>